module.exports = "<div class=\"col-xs-12 col-md-2 user--container\" title=\"Log out\">\n    <div class=\"user row\">\n        <div class=\"col-xs-12 user--name\" (click)=\"logout()\">\n            <span class=\"user--icon glyphicon glyphicon-off\"></span>\n            {{user.name}}\n        </div>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/user/user.component.html
// module id = 760
// module chunks = 0